module.exports = "/assets/kinley-page/cocktail_1.jpg?F3OCpea";